var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _text, _path36, _text2, _path37, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem34(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 750 289"
    },
    viewBox: "0 0 750 289",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .st4{fill:#bfbfbf}.st5{fill:#fff}.st12{fill:#369;fill-opacity:.502}.st13{font-family:&apos;ArialMT&apos;}.st14{font-size:11.4815px}\n  ")), /*#__PURE__*/React.createElement("path", {
    d: "M750 0H0v289.4h750V0z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    x1: 249.8122,
    x2: 219.3122,
    y1: 348.9492,
    y2: 409.9742,
    gradientTransform: "matrix(2.0635 0 0 -2.0635 -100.832 906.9491)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2431,
    style: {
      stopColor: "#000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5255,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M454.9 101.2l-12.4-23.9-116.6 47.5c-11.7 8-14.9 18.6-9.5 31.8 5 8.5 12.1 12.8 21.5 13 3.7.1 7.4-.8 10.9-2.7 5.3-3.2 23.2-14.2 53.9-33.2 30.5-19 47.9-29.8 52.2-32.5z",
    style: {
      fill: "url(#SVGID_1_)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M455.8 100.6L443 76.1l-.8.4-116.4 47.3h-.2c-8.3 5.4-12.6 12.7-12.8 21.9.1 3.9 1 7.8 2.9 11.6 5.2 8.7 12.6 13.2 22.3 13.4 4 .1 7.8-.8 11.6-2.7 0-.1.1-.3.4-.4 7.9-4.8 26.5-16.3 55.8-34.5 29.3-18.2 45.9-28.5 49.8-31l.6-.4-.4-1.1m-13.7-22l11.3 22.1c-.8.6-2 1.3-3.5 2.4-12.9 8-32.1 19.9-57.6 35.7-11.7 7.3-21.7 13.6-30.1 18.8-4.1 2.5-7.4 4.5-9.9 6-1.1.7-2 1.2-2.7 1.7-.8.5-1.2.8-1.2.8-3.4 1.7-6.9 2.5-10.5 2.5-8.9-.2-15.7-4.3-20.4-12.4-1.9-3.4-2.8-6.9-2.7-10.5.2-8.7 4.1-15.3 11.8-20v-.1l115.5-47z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    x1: 268.6646,
    x2: 263.8396,
    y1: 391.7195,
    y2: 401.2444,
    gradientTransform: "matrix(2.0635 0 0 -2.0635 -100.832 906.9491)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5a5a5a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5255,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5a5a5a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M446.4 74.2c-1-1.7-2.3-2.5-4.1-2.5-.8 0-1.5.2-2.3.6-2.3 1.4-3 3.4-2.1 6.2l12.8 24.6c1 1.7 2.5 2.5 4.3 2.6.7 0 1.4-.2 2.1-.5 2.4-1.7 3-3.8 1.9-6.4l-12.6-24.6z",
    style: {
      fill: "url(#SVGID_2_)"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M439.6 71.3c-2.1 1.2-3.1 3-3.1 5.2 0 .8.2 1.7.6 2.7l12.8 24.3c1.2 2.1 2.8 3.1 5 3.1 1 0 1.9-.2 2.7-.6 2-1.1 3-2.8 3.1-5 0-1-.2-1.9-.6-2.7l-12.8-24.6c-1.1-1.9-2.8-3-5-3.1-1 .1-1.9.3-2.7.7m1 1.7c.6-.1 1.1-.2 1.7-.3 1.4.1 2.4.8 3.1 2.1l12.8 24.6c.3.4.4 1 .4 1.7-.1 1.4-.8 2.4-2.1 3.1-.4.3-1 .5-1.7.4-1.3 0-2.3-.6-3.1-1.9L439 78.1c-.2-.6-.3-1.1-.4-1.7 0-1.5.7-2.6 2.1-3.3V73z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 35.5618,
    cy: 419.3615,
    r: 3.25,
    gradientTransform: "matrix(2.0635 0 0 -2.0635 301.3455 993.9252)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M378.6 126.5c-1-1.9-2.6-2.9-4.8-3-.8 0-1.6.2-2.4.5-2.9 1.7-3.7 4.1-2.5 7.2 1.1 2.1 2.8 3.1 5 3.2.8 0 1.6-.2 2.3-.5 2.9-1.7 3.7-4.2 2.4-7.4z",
    style: {
      fill: "url(#SVGID_3_)"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M380.3 129.1c0-1-.2-1.9-.6-2.9-1.4-2.3-3.4-3.4-5.8-3.5-1 0-2 .2-2.9.6-2.3 1.2-3.6 3.1-3.7 5.8 0 .9.3 1.8.8 2.7 1.2 2.3 3.1 3.6 5.8 3.7.9 0 1.8-.2 2.7-.6 2.3-1.3 3.5-3.3 3.7-5.8m-2.5-1.9c.3.6.4 1.2.4 1.9 0 1.8-.8 3.1-2.5 3.9-.6.3-1.2.5-1.9.4-1.9 0-3.3-.8-4.1-2.5-.2-.6-.3-1.2-.4-1.9 0-1.8.8-3.2 2.5-4.1.6-.3 1.2-.4 2.1-.4 1.7.1 3 1 3.9 2.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M393 130.5h-12.2c-.5 4.1-2.8 6.4-7 6.8-4.1-.4-6.4-2.7-6.8-6.8h-13.8v12h-20v16.1h-20v15.9h-40v20H393v-64z",
    className: "st4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M379.8 129.4v1c-.5 3.4-2.5 5.4-6 5.8-3.4-.4-5.4-2.3-5.8-5.8v-1h-15.9v12h-20v16.1h-20v15.9h-40v22.1h122v-66h-14.3m-6 8.8c4.3-.3 7-2.6 7.9-6.8H392v61.9H274.2v-18h40v-15.9h20v-16.1h20v-12h11.9c.8 4.3 3.4 6.6 7.7 6.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M391.6 194.5c-.6-6.4-4.1-9.9-10.5-10.5-6.3.6-9.8 4.1-10.3 10.5.6 6.4 4 9.9 10.3 10.5 6.5-.6 10-4.1 10.5-10.5z",
    className: "st5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M381.1 182.9c-6.9.6-10.7 4.5-11.3 11.6.7 7.1 4.5 10.9 11.3 11.6 7-.6 10.9-4.5 11.6-11.6-.7-7.1-4.5-10.9-11.6-11.6m6.9 4.7c1.7 1.9 2.6 4.1 2.7 6.8-.1 2.7-1 5-2.7 6.8-1.8 1.7-4.1 2.6-6.8 2.7-2.6-.1-4.8-1-6.6-2.7-1.7-1.9-2.6-4.1-2.7-6.8.1-2.7 1-5 2.7-6.8 1.8-1.7 4-2.6 6.6-2.7 2.7.1 5 1 6.8 2.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M386.2 194.5c-.3-3.2-2-4.9-5.2-5.2-3 .3-4.6 2-5 5.2.3 3.2 1.9 4.9 5 5.2 3.2-.3 4.9-2 5.2-5.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M381 188.4c-3.6.3-5.6 2.3-6 6 .3 3.6 2.3 5.6 6 6 3.9-.3 5.9-2.3 6.2-6-.3-3.6-2.3-5.6-6.2-6m4.2 6c-.2 2.5-1.6 3.9-4.1 4.1-2.3-.2-3.6-1.6-3.9-4.1.3-2.5 1.6-3.9 3.9-4.1 2.5.3 3.9 1.7 4.1 4.1zM299 194.5c-.6-6.4-4.1-9.9-10.5-10.5-6.4.6-9.9 4.1-10.5 10.5.6 6.4 4.1 9.9 10.5 10.5 6.4-.6 9.9-4.1 10.5-10.5z",
    className: "st5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M276.9 194.5c.7 7.1 4.5 10.9 11.6 11.6 7-.6 10.9-4.5 11.6-11.6-.7-7-4.5-10.9-11.6-11.6-7.1.6-10.9 4.5-11.6 11.6m11.6-9.5c2.7.1 5 1 6.8 2.7 1.7 1.9 2.6 4.1 2.7 6.8-.1 2.7-1 5-2.7 6.8-1.9 1.7-4.1 2.6-6.8 2.7-2.6-.1-4.8-1-6.6-2.7-1.9-1.9-2.8-4.1-2.9-6.8.1-2.7 1-5 2.9-6.8 1.7-1.8 3.9-2.7 6.6-2.7z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M293.5 194.5c-.3-3.2-2-4.9-5.2-5.2-3 .3-4.6 2-5 5.2.3 3.2 2 4.9 5 5.2 3.2-.3 4.9-2 5.2-5.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M288.3 188.4c-3.6.3-5.6 2.3-6 6 .3 3.6 2.3 5.6 6 6 3.7-.3 5.8-2.3 6.2-6-.4-3.6-2.5-5.6-6.2-6m4.2 6c-.3 2.5-1.7 3.9-4.1 4.1-2.5-.2-3.9-1.6-4.1-4.1.3-2.5 1.7-3.9 4.1-4.1 2.4.3 3.8 1.7 4.1 4.1z",
    className: "st5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    x1: 388.1816,
    x2: 378.3316,
    y1: 341.0345,
    y2: 412.3595,
    gradientTransform: "matrix(2.0635 0 0 -2.0635 -157.582 906.9491)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2431,
    style: {
      stopColor: "#000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5255,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M708 127.2l-4.5-26.4-125.3 9.9c-13.8 4.1-20 13.3-18.8 27.4 3.1 12.4 10.9 19.1 23.5 19.9 1.4.1 2.8 0 4.1-.3 6.1-1.4 26.6-6.6 61.4-15.4 34.9-8.8 54.7-13.8 59.6-15.1z",
    style: {
      fill: "url(#SVGID_4_)"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M704.3 99.8h-.8L578 109.7c-12.5 3.6-19.2 11.7-20 24.3 0 1.4.1 2.9.4 4.3 3.2 13 11.4 19.9 24.6 20.8 1.4 0 2.9-.1 4.3-.4.2-.1.8-.2 1.9-.4 11.5-2.9 33.2-8.4 65.2-16.5 32-8 50-12.6 54.1-13.6l.8-.2-.2-.8-4.5-26.6-.3-.8m-1.7 2.2l4.2 24.7c-.9.2-2.3.6-4.2 1-14.7 3.8-36.5 9.3-65.6 16.5-13.3 3.4-24.8 6.3-34.5 8.7-4.6 1.2-8.3 2.2-10.9 2.9-1.4.3-2.5.6-3.3.8-.8.1-1.3.2-1.4.2-1.2.3-2.5.4-3.9.4-12-.8-19.5-7.2-22.5-19.2-.3-1.2-.4-2.5-.4-3.9.8-11.7 6.9-19.1 18.4-22.3l124.1-9.8z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_5_",
    cx: 35.5618,
    cy: 419.3615,
    r: 3.35,
    gradientTransform: "matrix(2.0635 0 0 -2.0635 549.4787 993.9252)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M627.7 128.5c-.8-2.9-2.6-4.4-5.5-4.6-.3 0-.5 0-.7.1-3.4.7-5 2.8-4.7 6.2.6 2.8 2.4 4.3 5.4 4.5h.8c3.3-.8 4.8-2.9 4.7-6.2z",
    style: {
      fill: "url(#SVGID_5_)"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M628.8 129.3c-.1-.3-.1-.6-.2-.8-.8-3.5-2.8-5.4-6.2-5.6h-1c-3.4.8-5.3 2.9-5.6 6.4.1.3.1.6.2.8.7 3.5 2.8 5.4 6.4 5.6h.8c3.3-.8 5.2-3 5.6-6.4m-2.1-.6v.6c-.1 2.5-1.4 3.9-3.9 4.3-.3.1-.4.1-.4.2-2.5-.1-4-1.4-4.5-3.9v-.6c.2-2.5 1.5-3.9 3.9-4.3.2-.2.4-.3.6-.2 2.2.1 3.7 1.4 4.3 3.9z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M641.4 130.5h-12.2c-.5 4.1-2.8 6.4-7 6.8-4.1-.4-6.4-2.7-6.8-6.8h-14v12h-19.8v16.1h-20v15.9h-40v20h119.9v-64z",
    className: "st4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M628.3 129.4v1c-.4 3.4-2.4 5.4-6 5.8-3.5-.4-5.4-2.3-5.8-5.8v-1h-16.1v12h-19.8v16.1h-20v15.9h-40v22.1h122v-66h-14.3m-6 8.8c4.3-.3 7-2.6 7.9-6.8h10.2v61.9H522.6v-18h40v-15.9h20v-16.1h19.8v-12h12.1c.9 4.3 3.4 6.6 7.8 6.9z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M640 194.5c-.5-6.4-4-9.9-10.5-10.5-6.4.6-9.9 4.1-10.5 10.5.6 6.4 4.1 9.9 10.5 10.5 6.5-.6 10-4.1 10.5-10.5z",
    className: "st5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M617.9 194.5c.8 7.1 4.6 10.9 11.6 11.6 7.1-.6 10.9-4.5 11.6-11.6-.6-7-4.5-10.9-11.6-11.6-7 .6-10.8 4.5-11.6 11.6m11.6-9.5c2.8.1 5 1 6.8 2.7 1.7 1.9 2.6 4.1 2.7 6.8-.1 2.7-1 5-2.7 6.8-1.7 1.7-4 2.6-6.8 2.7-2.6-.1-4.8-1-6.6-2.7-1.8-1.9-2.8-4.1-2.9-6.8.1-2.7 1.1-5 2.9-6.8 1.7-1.8 3.9-2.7 6.6-2.7z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M634.7 194.5c-.3-3.2-2-4.9-5.2-5.2-3 .3-4.7 2-5 5.2.3 3.2 1.9 4.9 5 5.2 3.2-.3 4.9-2 5.2-5.2z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M629.5 188.4c-3.6.3-5.6 2.3-6 6 .3 3.6 2.3 5.6 6 6 3.8-.3 5.8-2.3 6.2-6-.3-3.6-2.4-5.6-6.2-6m4.2 6c-.3 2.5-1.7 3.9-4.1 4.1-2.5-.2-3.8-1.6-3.9-4.1.2-2.5 1.5-3.9 3.9-4.1 2.4.3 3.8 1.7 4.1 4.1zM547.3 194.5c-.6-6.4-4.1-9.9-10.5-10.5-6.4.6-9.9 4.1-10.5 10.5.6 6.4 4.1 9.9 10.5 10.5 6.4-.6 9.9-4.1 10.5-10.5z",
    className: "st5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M525.2 194.5c.6 7.1 4.5 10.9 11.6 11.6 7.1-.6 10.9-4.5 11.6-11.6-.6-7-4.5-10.9-11.6-11.6-7 .6-10.9 4.5-11.6 11.6m11.6-9.5c2.7.1 5 1 6.8 2.7 1.7 1.9 2.6 4.1 2.7 6.8-.1 2.7-1 5-2.7 6.8-1.9 1.7-4.1 2.6-6.8 2.7-2.7-.1-4.9-1-6.6-2.7-1.9-1.9-2.8-4.1-2.9-6.8 0-2.7 1-5 2.9-6.8 1.7-1.8 3.9-2.7 6.6-2.7z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M542 194.5c-.3-3.2-2-4.9-5.2-5.2-3 .3-4.6 2-5 5.2.3 3.2 2 4.9 5 5.2 3.2-.3 4.9-2 5.2-5.2z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M536.8 188.4c-3.6.3-5.6 2.3-6 6 .3 3.6 2.3 5.6 6 6 3.6-.3 5.6-2.3 6-6-.4-3.6-2.4-5.6-6-6m4.1 6c-.2 2.5-1.6 3.9-4.1 4.1-2.5-.2-3.9-1.6-4.1-4.1.3-2.5 1.7-3.9 4.1-4.1 2.5.3 3.9 1.7 4.1 4.1z",
    className: "st5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    x1: 305.9655,
    x2: 301.1405,
    y1: 387.1458,
    y2: 396.6708,
    gradientTransform: "matrix(1.9701 .607 .607 -1.9701 -130.2737 700.9134)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5a5a5a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5255,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5a5a5a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M707.9 98.5c-.4-1.9-1.5-3.1-3.2-3.6-.7-.2-1.5-.2-2.3-.1-2.6.6-3.9 2.4-3.8 5.3l5 27.2c.5 1.9 1.6 3.1 3.4 3.7.7.2 1.4.2 2.1.1 2.8-.9 4-2.7 3.7-5.6l-4.9-27z",
    style: {
      fill: "url(#SVGID_6_)"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M709.2 99c-.8-2.9-2.8-4.5-5.8-4.7h-.8c-3 .8-4.6 2.8-4.7 5.8v.8l4.7 27.2c.8 3 2.6 4.6 5.6 4.7h1c2.9-.8 4.5-2.7 4.7-5.6 0-.4-.1-.8-.2-1L709.2 99m-9.3 1.6v-.6c.1-1.9 1.1-3.2 2.9-3.7h.6c1.9.1 3.2 1.2 3.7 3.1l4.5 27.2c.1.2.2.4.2.6-.1 1.8-1.1 3-3.1 3.5h-.6c-1.9-.1-3.1-1.1-3.5-2.9l-4.7-27.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    x1: 106.1974,
    x2: 66.5474,
    y1: 369.9347,
    y2: 394.3097,
    gradientTransform: "matrix(2.0635 0 0 -2.0635 -37.282 906.9491)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2431,
    style: {
      stopColor: "#000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5255,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M189.4 60.8L165.9 48 95.7 152.4c-5.3 13.1-2 23.7 9.9 31.8 3.6 1.9 7.4 2.9 11.3 2.9 9.1-.1 16.2-4.3 21.3-12.6 2.5-5.6 11.2-24.8 26-57.6s23.2-51.5 25.2-56.1z",
    style: {
      fill: "url(#SVGID_7_)"
    }
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M190.3 61.2l.2-.8-25.2-13.8-.4.8-70.1 104.3h-.2c-1.7 3.7-2.6 7.4-2.7 11.1.2 9.5 4.6 16.9 13.2 22.1 3.8 2.1 7.8 3.1 12 3.1 9.4-.2 16.6-4.5 21.9-13 .1-.2.1-.4.2-.6 3.9-8.4 12.9-28.3 27-59.8 14.1-31.4 22.1-49.3 24.1-53.4M188 61c-.3.8-.9 2.1-1.8 4-6.2 13.8-15.5 34.5-27.9 61.9-5.5 12.6-10.3 23.3-14.4 32.2-2 4.5-3.6 8-4.7 10.5-.6 1.2-1 2.3-1.4 3.1-.3.7-.5 1.1-.6 1.2-4.7 7.8-11.3 11.8-20 12-3.8-.1-7.5-1-11.1-2.9-7.8-4.7-11.8-11.4-12-20.2 0-3.4.8-6.7 2.5-10.1l69.6-103.5L188 61z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    x1: 111.0671,
    x2: 96.7421,
    y1: 409.5795,
    y2: 417.2045,
    gradientTransform: "matrix(2.0635 0 0 -2.0635 -37.282 906.9491)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5255,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M167.3 43.3c-.8-.4-1.5-.6-2.3-.6-1.8 0-3.2.8-4.1 2.5-1.2 2.6-.6 4.7 1.9 6.4l24.3 13.2c.7.3 1.4.5 2.2.5 1.7 0 3.1-.8 4-2.4 1.1-2.7.5-4.8-1.9-6.4l-24.1-13.2z",
    style: {
      fill: "url(#SVGID_8_)"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M194.9 60.6c0-2.1-1-3.8-2.9-5l-24.3-13.2c-.8-.6-1.7-.8-2.7-.8-2.1 0-3.8 1-5 3.1-.5.8-.8 1.7-.8 2.7.1 2.2 1.2 3.9 3.1 5l24.1 13.2c1 .6 1.9.9 2.9.8 2.1-.1 3.7-1.1 5-3.1.4-.8.6-1.7.6-2.7m-2.5 1.6c-.7 1.3-1.7 2-3.1 2.1-.6 0-1.2-.1-1.9-.4l-24.1-13.4c-1.3-.7-2-1.7-2.1-3.1 0-.6.2-1.2.6-1.9.8-1.1 1.8-1.7 3.1-1.9.6.1 1.2.2 1.9.4L191 57.5c1.2.8 1.9 1.8 1.9 3.1 0 .7-.1 1.2-.5 1.6z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_9_",
    cx: 35.5618,
    cy: 419.3615,
    r: 3.7,
    gradientTransform: "matrix(2.0635 0 0 -2.0635 64.8616 993.6157)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M140.3 124.6c-.8-.5-1.7-.7-2.7-.7-1.9 0-3.5.9-4.7 2.8-1.4 2.9-.7 5.4 2.1 7.4.8.5 1.7.7 2.6.7 2-.1 3.6-1 4.8-2.8 1.3-2.9.7-5.4-2.1-7.4z",
    style: {
      fill: "url(#SVGID_9_)"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M131.9 126c-.6 1.1-.8 2.2-.8 3.3.1 2.4 1.2 4.3 3.1 5.6 1.1.6 2.2.8 3.3.8 2.4 0 4.3-1 5.6-3.1.6-1.1.9-2.2.8-3.3 0-2.3-1-4.2-3.1-5.6-1-.6-2.1-.9-3.3-.8-2.2 0-4.1 1-5.6 3.1m1.9 1c1-1.5 2.2-2.3 3.7-2.3.9 0 1.7.2 2.3.6 1.5 1 2.3 2.3 2.3 3.9 0 .8-.2 1.5-.6 2.3-.9 1.4-2.2 2.2-3.9 2.3-.8 0-1.5-.2-2.3-.6-1.4-1-2.1-2.3-2.1-3.9 0-.8.2-1.6.6-2.3z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M157 130.5h-12.2c-.5 4.1-2.8 6.4-7 6.8-4.1-.4-6.4-2.7-6.8-6.8h-13.8v12h-20v16.1h-20v15.9h-40v20H157v-64z",
    className: "st4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M143.8 129.4v1c-.5 3.4-2.5 5.4-6 5.8-3.5-.4-5.4-2.3-5.8-5.8v-1h-15.9v12h-20v16.1h-20v15.9h-40v22.1h122v-66h-14.3m-6 8.8c4.3-.3 7-2.6 7.9-6.8H156v61.9H38.2v-18h40v-15.9h20v-16.1h20v-12h11.9c.8 4.3 3.4 6.6 7.7 6.9z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M155.5 194.5c-.5-6.4-4-9.9-10.5-10.5-6.3.6-9.8 4.1-10.3 10.5.6 6.4 4 9.9 10.3 10.5 6.4-.6 9.9-4.1 10.5-10.5z",
    className: "st5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M144.9 182.9c-6.9.6-10.7 4.5-11.3 11.6.7 7.1 4.5 10.9 11.3 11.6 7.1-.6 10.9-4.5 11.6-11.6-.6-7.1-4.5-10.9-11.6-11.6m6.9 4.7c1.7 1.9 2.6 4.1 2.7 6.8-.1 2.7-1 5-2.7 6.8-1.8 1.7-4.1 2.6-6.8 2.7-2.6-.1-4.8-1-6.6-2.7-1.7-1.9-2.6-4.1-2.7-6.8.1-2.7 1-5 2.7-6.8 1.8-1.7 4-2.6 6.6-2.7 2.7.1 5 1 6.8 2.7z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M150.1 194.5c-.3-3.2-2-4.9-5.2-5.2-3 .3-4.6 2-5 5.2.3 3.2 2 4.9 5 5.2 3.2-.3 4.9-2 5.2-5.2z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M145 188.4c-3.6.3-5.6 2.3-6 6 .3 3.6 2.3 5.6 6 6 3.9-.3 5.9-2.3 6.2-6-.3-3.6-2.4-5.6-6.2-6m4.1 6c-.3 2.5-1.7 3.9-4.1 4.1-2.3-.2-3.6-1.6-3.9-4.1.3-2.5 1.6-3.9 3.9-4.1 2.5.3 3.8 1.7 4.1 4.1zM62.8 194.5c-.6-6.4-4.1-9.9-10.5-10.5-6.4.6-9.9 4.1-10.5 10.5.6 6.4 4.1 9.9 10.5 10.5 6.4-.6 9.9-4.1 10.5-10.5z",
    className: "st5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8 194.5c.6 7.1 4.5 10.9 11.6 11.6 7.1-.6 10.9-4.5 11.6-11.6-.6-7-4.5-10.9-11.6-11.6-7.1.6-10.9 4.5-11.6 11.6m11.6-9.5c2.7.1 5 1 6.8 2.7 1.7 1.9 2.6 4.1 2.7 6.8-.1 2.7-1 5-2.7 6.8-1.9 1.7-4.1 2.6-6.8 2.7-2.6-.1-4.8-1-6.6-2.7-1.9-1.9-2.8-4.1-2.9-6.8.1-2.7 1-5 2.9-6.8 1.7-1.8 3.9-2.7 6.6-2.7z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6 194.5c-.3-3.2-2-4.9-5.2-5.2-3 .3-4.7 2-5 5.2.3 3.2 1.9 4.9 5 5.2 3.2-.3 4.9-2 5.2-5.2z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4 188.4c-3.6.3-5.6 2.3-6 6 .3 3.6 2.3 5.6 6 6 3.7-.3 5.8-2.3 6.2-6-.4-3.6-2.5-5.6-6.2-6m4.2 6c-.3 2.5-1.7 3.9-4.1 4.1-2.5-.2-3.9-1.6-4.1-4.1.2-2.5 1.6-3.9 4.1-4.1 2.4.3 3.8 1.7 4.1 4.1z",
    className: "st5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M114 214.9c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7 0 3.4 1.2 6.3 3.6 8.7 2.4 2.4 5.3 3.6 8.7 3.6 3.4 0 6.2-1.2 8.6-3.6 2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    className: "st12"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "st5 st13 st14",
    transform: "matrix(.9981 0 0 1 101.4673 228.5181)"
  }, "\n    1\n  ")), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M344.6 214.9c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7 0 3.4 1.2 6.3 3.6 8.7 2.4 2.4 5.3 3.6 8.7 3.6 3.4 0 6.2-1.2 8.6-3.6 2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    className: "st12"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "st5 st13 st14",
    transform: "matrix(.9981 0 0 1 332.0674 228.5181)"
  }, "\n    2\n  ")), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M593.6 214.9c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7 0 3.4 1.2 6.3 3.6 8.7 2.4 2.4 5.3 3.6 8.7 3.6 3.4 0 6.2-1.2 8.6-3.6 2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    className: "st12"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "st5 st13 st14",
    transform: "matrix(.9981 0 0 1 581.0674 228.5181)"
  }, "\n    3\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem34);
export default __webpack_public_path__ + "static/media/item34.b44f0497e6874c9b202cc2dc6fb39ace.svg";
export { ForwardRef as ReactComponent };